<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" >
    <el-row>
        <el-col :span="12">
          <el-form-item label="活动名称" label-position="left" prop="activityName">
            <el-input v-model="ruleForm.activityName" placeholder="请输入标题（不超过30个汉字）" style="width: 60%;"  >
            </el-input>
          </el-form-item>
          <el-form-item label="活动日期" label-position="left" prop="activeTime">
            <el-date-picker
              v-model="ruleForm.activeTime"
              type="datetimerange"
              placeholder="选择时间范围">
            </el-date-picker>
          </el-form-item>
          <quill-editor v-model="ruleForm.activityInfo"
              ref="myQuillEditor"
              :options="editorOption"
              style="width:100%;height: 267pt;"
              >
          </quill-editor>
        </el-col>
        <el-col :span="12">
          <div  class="wf-formcanvas wf-inner">
           <div data-reactid=".0.2.1.1" class="wf-formcanvas-inner">

             <div class="ql-container ql-snow" style="border:none;">
               <div class="ql-editor" style="height: 424pt;" v-html="ruleForm.activityInfo">
               </div>
               <!-- <quill-editor v-model="ruleForm.activityInfo"
                   ref="myQuillEditor"
                   style="width:100%;height: 338pt;"
                   > -->
               <!-- </quill-editor> -->
             </div>
           </div>
         </div>
        </el-col>
        <el-col :span="12">
          <div style="text-align:left;" class="basic-margin">
            <el-button type="primary" @click="validateFrom('ruleForm',isEdit?editForm:submitForm)">发布</el-button>
            <el-button @click="$router.go(-1)">取消</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-form>
</template>

<script>
import UploadModel from '../../../framework/models/uploadModel'
import LocalNewsModel from '@/framework/models/localNewsModel'
import businessModel from '../../../framework/models/businessModel'
import { quillEditor } from 'vue-quill-editor'
import { quillRedefine } from 'vue-quill-editor-upload'
import BasicPager from '../../../mixins/BasicPager'
import Config from '../../../framework/configs/Config'
export default {
  name: 'add-active-dialog',
  extends: BasicPager,
  data: function () {
    var validateDate = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('请选择日期'))
      } else {
        callback()
      }
    }
    return {
      isEdit: false,
      businessId: null,
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      ruleForm: {
        activityName: '',
        activityInfo: '',
        activeTime: []
      },
      rules: {
        activityName: [
          { required: true, message: '标题不能为空', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        activeTime: [
          { validator: validateDate, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    quillEditor, quillRedefine
  },
  created: function () {
    let _this = this
    let params = this.$route.params
    _this.businessId = params.businessId
    if (params.businessActiveId) {
      _this.isEdit = true
      _this.businessActiveId = params.businessActiveId
      _this.initPageData(params.businessActiveId)
    }
    this.editorOption = quillRedefine(
      {
        // 图片上传的设置
        uploadConfig: {
          action: _this.baseUrl + '/upload/uploadQuillEditorPic', // 必填参数 图片上传地址
          // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
          // 你必须把返回的数据中所包含的图片地址 return 回去
          res: (respnse) => {
            return Config.imageUrl + respnse.datas
          },
          methods: 'POST', // 可选参数 图片上传方式  默认为post
          token: sessionStorage.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
          name: 'file', // 可选参数 文件的参数名 默认为img
          size: 50000, // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
          accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon', // 可选参数 可上传的图片格式
          // input点击事件  formData是提交的表单实体
          change: (formData) => {
          },
          // 设置请求头 xhr: 异步请求， formData: 表单对象
          header: (xhr, formData) => {
          },
          start: () => {
          }, // 可选参数 接收一个函数 开始上传数据时会触发
          end: () => {
          }, // 可选参数 接收一个函数 上传数据完成（成功或者失败）时会触发
          success: (val) => {

          }, // 可选参数 接收一个函数 上传数据成功时会触发
          error: () => {
          } // 可选参数 接收一个函数 上传数据中断时会触发
        },
        // 以下所有设置都和vue-quill-editor本身所对应
        placeholder: '请输入内容', // 可选参数 富文本框内的提示语
        theme: '', // 可选参数 富文本编辑器的风格
        handlers: {} // 可选参数 重定义的事件，比如link等事件
      }
    )
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    }
  },
  methods: {
    initPageData: function (businessActiveId) {
      let that = this
      let listener = {
        success: function (dataInfo) {
          let data = dataInfo.datas
          that.ruleForm.activityName = data.activityName
          that.ruleForm.activityInfo = data.activityInfo
          that.ruleForm.activeTime.push(data.startTime)
          that.ruleForm.activeTime.push(data.endTime)
        }
      }

      businessModel.selectBusinessActiveById(that, { 'businessActiveId': businessActiveId }, listener)
    },
    editForm: function () {
      let _this = this
      let params = _this.$data.ruleForm
      let activeTime = _this.ruleForm.activeTime
      if (activeTime && activeTime.length > 0 && activeTime[0]) {
        params.startTime = new Date(activeTime[0]).getTime()
        params.endTime = new Date(activeTime[1]).getTime()
      }
      params.businessActiveId = _this.businessActiveId

      // params.userId =  _this.loginInfo.loginPath=='cxh'?[]:[loginInfo.id]
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            message: '修改成功',
            type: 'success'
          })
          _this.$router.push({ name: '商家活动', params: { businessId: _this.businessId } })
        }
      }

      businessModel.updateBusinessActive(_this, params, listener)
    },
    submitForm: function () {
      let _this = this
      let params = _this.$data.ruleForm
      let activeTime = _this.ruleForm.activeTime
      if (activeTime && activeTime.length > 0 && activeTime[0]) {
        params.startTime = activeTime[0].getTime()
        params.endTime = activeTime[1].getTime()
      }
      params.businessId = _this.businessId
      // params.userId =  _this.loginInfo.loginPath=='cxh'?[]:[loginInfo.id]
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            message: '添加成功',
            type: 'success'
          })
          _this.$router.push({ name: '商家活动', params: { businessId: _this.businessId } })
        }
      }
      businessModel.addBusinessActive(_this, params, listener)
    }

  }
}
</script>

<style media="screen" >
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    padding-top: 71px;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  input[type=file] {
    display: none;
  }
  .content-lable{
    vertical-align: middle;
    font-size: 14px;
    color: #48576a;
    line-height: 1;
    padding: 1px 1px 1px 0;
    box-sizing: border-box;
  }

  .wf-formcanvas {
    padding-top: 85px;
    padding-left: 40px;
    padding-right: 38px;
    padding-bottom: 116px;
    left: 50%;
    top: 0;
    height: 766px;
    width: 421px;
    background: url(http://test.cqsxbkj.cn/clue/static/phone.png) no-repeat top center;
    -webkit-background-size: 100% 100%;
    margin-left: auto;
    margin-right: auto;
}
.wf-formcanvas-inner {
    left: 38px;
    top: 84px;
    right: 38px;
    bottom: 0;
    max-height: 562px;
    background: #f0eff4;

}

.wf-formcanvas .ql-container {
  height: 100%;
}
</style>
